import type { CSSProperties, ReactNode } from 'react';

export const getJustifyStyle = (leftItem: ReactNode | undefined, rightItem: ReactNode | undefined): CSSProperties['justifyContent'] => {
    if (leftItem && rightItem)
        return 'space-between';
    if (!leftItem && rightItem)
        return 'end';
    return undefined;
};
